<template>
  <div class="retail">
    <headers></headers>
    <div class="banner">
      <img src="../assets/1banner@2x.png" width="100%" alt />
    </div>
    <main>
      <el-row style="margin: 40px 0;" class="canpin">
        <el-col :span="24">
          <div class="grid-content bg-purple-dark">
            <h3 style="font-weight: 800;font-size: 36px;margin-bottom: 19px;">产品功能</h3>
            <p style="font-size: 16px;">PRODUCT FUNCTION</p>
          </div>
        </el-col>
      </el-row>
      <div class="smallcanpin">
        <h2>产品功能</h2>
      </div>
      <el-row class="main_top">
        <el-col :span="24">
          <div class="grid-content bg-purple-dark">
            <h4>收银机 零售版管理</h4>
            <p>专业收银软件/会员定制服务/科学店务管理</p>
          </div>
        </el-col>
      </el-row>

      <el-row class="shangpin">
        <el-col :span="24" style="display:flex;justify-content: center">
          <div class="box">
            <div class="infobox">
              <p style="height:50px">
                <img src="../assets/科学验光@2x.png" alt />
              </p>
              <p>科学验光</p>
              <p>对每一位顾客的验光记录</p>
              <p>形成视光健康记录表，</p>
              <p>多方面保护顾客视光健康</p>
            </div>
          </div>
          <div class="box">
            <div class="infobox">
              <p>
                <img src="../assets/商品erp系统@2x.png" alt width="50px" />
              </p>
              <p>商品ERP系统</p>
              <p>现代企业管理的运行模式，</p>
              <p>覆盖了客户、商品库存和批发</p>
              <p>商供应等管理工作…</p>
            </div>
          </div>
          <div class="box">
            <div class="infobox">
              <p>
                <img src="../assets/扫码-full@2x.png" alt />
              </p>
              <p>科学验光</p>
              <p>所有商品扫码入库、销售，</p>
              <p>通过唯一码可以追溯到</p>
              <p>商品源头与售后的行踪</p>
            </div>
          </div>
          <div class="box">
            <div class="infobox">
              <p>
                <img src="../assets/顾客列表@2x.png" alt />
              </p>
              <p>顾客CRM系统</p>
              <p>协调企业与顾客间在销售、</p>
              <p>营销和服务上的交互</p>
              <p>为顾客提供个性化服务</p>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row class="shangpin">
        <el-col :span="24" style="display:flex;justify-content: center">
          <div class="box">
            <div class="infobox">
              <p style="height:50px">
                <img src="../assets/价格策略@2x.png" alt />
              </p>
              <p>价格策略</p>
              <p>对每一位顾客的验光记录</p>
              <p>形成视光健康记录表，</p>
              <p>多方面保护顾客视光健康</p>
            </div>
          </div>
          <div class="box">
            <div class="infobox">
              <p>
                <img src="../assets/vs 视频监控@2x.png" alt width="50px" />
              </p>
              <p>信息实时推送</p>
              <p>收银机可实时接收手</p>
              <p>机端的信息，推送到收</p>
              <p>银机界面机器人</p>
            </div>
          </div>
          <div class="box">
            <div class="infobox">
              <p>
                <img src="../assets/盘点@2x.png" alt />
              </p>
              <p>智能盘点</p>
              <p>门店商品分类盘点</p>
              <p>问题商品特别标记</p>
              <p>盘点单自动生成……</p>
            </div>
          </div>
          <div class="box">
            <div class="infobox">
              <p>
                <img src="../assets/我的绩效@2x.png" alt />
              </p>
              <p>绩效打卡</p>
              <p>员工上班打卡</p>
              <p>个人账号管理</p>
              <p>考勤记录实时同步</p>
            </div>
          </div>
        </el-col>
      </el-row>
      <!-- 移动端商品 -->
      <div class="smallshangpin">
        <ul>
          <li>
            <div class="infobox">
              <p>
                <img src="../assets/科学验光@2x.png" alt />
              </p>
              <p>科学验光</p>
              <p>对每一位顾客的验光记录</p>
              <p>形成视光健康记录表，</p>
              <p>多方面保护顾客视光健康</p>
            </div>
          </li>
          <li>
            <div class="infobox1">
              <p>
                <img src="../assets/商品erp系统@2x.png" alt width="50px" />
              </p>
              <p>商品ERP系统</p>
              <p>现代企业管理的运行模式，</p>
              <p>覆盖了客户、商品库存和批发</p>
              <p>商供应等管理工作…</p>
            </div>
          </li>
          <li>
            <div class="infobox1">
              <p>
                <img src="../assets/扫码-full@2x.png" alt />
              </p>
              <p>科学验光</p>
              <p>所有商品扫码入库、销售，</p>
              <p>通过唯一码可以追溯到</p>
              <p>商品源头与售后的行踪</p>
            </div>
          </li>
          <li>
            <div class="infobox1">
              <p>
                <img src="../assets/顾客列表@2x.png" alt />
              </p>
              <p>顾客CRM系统</p>
              <p>协调企业与顾客间在销售、</p>
              <p>营销和服务上的交互</p>
              <p>为顾客提供个性化服务</p>
            </div>
          </li>
          <li>
            <div class="infobox1">
              <p>
                <img src="../assets/价格策略@2x.png" alt />
              </p>
              <p>价格策略</p>
              <p>对每一位顾客的验光记录</p>
              <p>形成视光健康记录表，</p>
              <p>多方面保护顾客视光健康</p>
            </div>
          </li>
          <li>
            <div class="infobox1">
              <p>
                <img src="../assets/vs 视频监控@2x.png" alt width="50px" />
              </p>
              <p>信息实时推送</p>
              <p>收银机可实时接收手</p>
              <p>机端的信息，推送到收</p>
              <p>银机界面机器人</p>
            </div>
          </li>
          <li>
            <div class="infobox1">
              <p>
                <img src="../assets/盘点@2x.png" alt />
              </p>
              <p>智能盘点</p>
              <p>门店商品分类盘点</p>
              <p>问题商品特别标记</p>
              <p>盘点单自动生成……</p>
            </div>
          </li>
          <li>
            <div class="infobox">
              <p>
                <img src="../assets/我的绩效@2x.png" alt />
              </p>
              <p>绩效打卡</p>
              <p>员工上班打卡</p>
              <p>个人账号管理</p>
              <p>考勤记录实时同步</p>
            </div>
          </li>
        </ul>
      </div>
    </main>

    <div class="science">
      <div class="smallscience">
        <h2>技术规格</h2>
      </div>
      <el-row class="science_top">
        <el-col :span="24">
          <div class="grid-content bg-purple-dark">
            <h4>收银机 技术规格</h4>
            <p>全功能触摸一体收银机</p>
          </div>
        </el-col>
      </el-row>

      <el-row>
        <el-col class="smalllunbotu" :xs="{span:16,offset:4}">
          <img src="../assets/tu@2x.png" alt width="100%" />
        </el-col>
        <el-col :sm="{span:6,offset:6}" :xs="{span:24,offset:4}" class="xiangqing">
          <div class="grid-content bg-purple science_left">
            <p>技术规格</p>
            <p>主显显示屏：15.6寸电容触摸</p>
            <p>客显显示屏：9寸宽视角</p>
            <p>&nbsp;</p>
            <p>系统：Android6.0.1</p>
            <p>主频：1.8GHZ</p>
            <p>内存：2G</p>
            <p>闪存：8GB</p>
            <p>通讯：以太网/WIFI/蓝牙</p>
            <p>内置打印机装纸容量：直径80MM</p>
            <p>打印速度：260MM/秒</p>
          </div>
        </el-col>
        <el-col :sm="{span:7}" class="lunbotu">
          <div class="grid-content bg-purple-light">
            <el-carousel indicator-position="outside">
              <el-carousel-item>
                <img src="../assets/tu@2x.png" alt width="100%" />
              </el-carousel-item>
              <el-carousel-item>
                <img src="../assets/tu@2x.png" alt width="100%" />
              </el-carousel-item>
              <el-carousel-item>
                <img src="../assets/tu@2x.png" alt width="100%" />
              </el-carousel-item>
            </el-carousel>
          </div>
        </el-col>
      </el-row>

      <el-row style="margin-top:10px;">
        <el-col :lg="{span:16,offset:4}" :md="{span:24,offset:0}">
          <el-row>
            <el-col :span="8" :xs="{span:24,offset:4}">
              <div class="yyy">
                <img src="../assets/材料@2x.png" alt width="20px;" />
                <span>主显示屏采用军工级别铝合金材料</span>
              </div>
            </el-col>
            <el-col :span="8" :xs="{span:24,offset:4}">
              <div class="yyy">
                <img src="../assets/塑料@2x.png" alt width="20px;" />
                <span>机器壳身采用高强度abs塑料</span>
              </div>
            </el-col>
            <el-col :span="8" :xs="{span:24,offset:4}">
              <div class="yyy">
                <img src="../assets/小票打印机@2x.png" alt width="20px;" />
                <span>自带切纸功能的热敏小票打印机</span>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
    <!-- 特色效果 -->
    <div class="feature">
      <el-row style="text-align: center;">
        <el-col :span="24">
          <div class="grid-content bg-purple-dark" style="margin: 40px 0;">
            <h4 style="font-weight: 400;font-size: 36px;margin-bottom: 19px;color:#fff">8大特色功能</h4>
            <p style="font-size: 17px;color:#fff">为眼镜行业专业定制</p>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2" :offset="11">
          <div class="grid-content_1">
            <div class="imgBox">
              <img src="../assets/矩形 817@2x.png" alt width="100px;" />
              <b>1</b>
              <div class="imgBoxInfo" style="width:284px;">
                <p style="color: #1874ed;font-size: 18px;margin-top:8px">新建验光</p>
                <p>添加客户信息，客户在实体店内验光；</p>
                <p>保留验光信息，可下次查看顾客信息。</p>
              </div>
            </div>
          </div>
          <div class="grid-content_1">
            <div class="imgBox">
              <img src="../assets/矩形 817@2x(1).png" alt width="100px" height="80px" />
              <b>2</b>
              <div class="imgBoxInfo" style="width:300px;left:-300px;text-align: right;">
                <p style="color: #1874ed;font-size: 18px;margin-top:8px">挂起功能</p>
                <p>单据可不用即时付款，销售单挂在后台；</p>
                <p>如需付款可调出销售单进销售单支付。</p>
              </div>
            </div>
          </div>
          <div class="grid-content_1">
            <div class="imgBox">
              <img src="../assets/矩形 817@2x(2).png" alt width="100px" />
              <b>3</b>
              <div class="imgBoxInfo" style="width:275px;">
                <p style="color: #1874ed;font-size: 18px;margin-top:8px">购物车</p>
                <p>添加和减少商品销售的数量，一键清</p>
                <p>空/挂起/折扣/一口价/调拨/退货……</p>
              </div>
            </div>
          </div>
          <div class="grid-content_1">
            <div class="imgBox">
              <img src="../assets/矩形 817@2x(3).png" alt width="100px" height="80px" />
              <b>4</b>
              <div class="imgBoxInfo" style="left:-231px;text-align: right;width:231px;">
                <p style="color: #1874ed;font-size: 18px;margin-top:8px">收银功能</p>
                <p>模拟超市收银，点击付款后，</p>
                <p>顾客出示二维码，扫码支付。</p>
              </div>
            </div>
          </div>
          <div class="grid-content_1">
            <div class="imgBox">
              <img src="../assets/矩形 817@2x(4).png" alt width="100px" />
              <b>5</b>
              <div class="imgBoxInfo" style="width:298px">
                <p style="color: #1874ed;font-size: 18px;margin-top:8px">生成加工</p>
                <p>配置镜架镜框后在销售详情中点击生成加</p>
                <p>工，添加加工单/加工中心接收/进行加工。</p>
              </div>
            </div>
          </div>
          <div class="grid-content_1">
            <div class="imgBox">
              <img src="../assets/矩形 817@2x(5).png" alt width="100px" height="80px" />
              <b>6</b>
              <div class="imgBoxInfo" style="left:-354px;text-align: right;width:354px">
                <p style="color: #1874ed;font-size: 18px; margin-top:8px;">销售功能</p>
                <p>顾客可在营业主页购买镜片/镜架/太阳眼镜/隐</p>
                <p>形眼镜等商品进行购买，结算完成后打印小票。</p>
              </div>
            </div>
          </div>
          <div class="grid-content_1">
            <div class="imgBox">
              <img src="../assets/矩形 817@2x(6).png" alt width="100px" />
              <b>7</b>
              <div class="imgBoxInfo" style="width:384px">
                <p style="color: #1874ed;font-size: 18px;margin-top:8px">VIP会员</p>
                <p>顾客可插叙自己的基本信息/验光信息及会员等级</p>
                <p>新增会员可通过微信扫二维码，填写信息成为会员。</p>
              </div>
            </div>
          </div>
          <div class="grid-content_1">
            <div class="imgBox">
              <img src="../assets/矩形 817@2x(7).png" alt width="100px" height="80px" />
              <b>8</b>
              <div class="imgBoxInfo" style="left:-321px;text-align: right;width:321px;">
                <p style="color: #1874ed;font-size: 18px;margin-top:8px">问题商品</p>
                <p>店员可将损坏或不合格产品进行归类报损，</p>
                <p>然后退回库存，问题较小产品可再次入库。</p>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <!-- 样机展示 -->
    <div class="proto">
      <div class="smallproto">
        <h2>样机细节展示</h2>
      </div>
      <el-row class="proto_top">
        <el-col :span="24">
          <div class="grid-content bg-purple-dark">
            <h4>样机细节展示</h4>
            <p>带给您不一样的视觉体验</p>
          </div>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <div class="proto_b">
            <img src="../assets/yangji.png" alt />
            <br />
            <img src="../assets/1Pro3-1@2x.png" width="620px" alt />
            <br />
            <img src="../assets/1Pro3-2@2x.png" width="620px" alt />
            <br />
            <img src="../assets/1Pro3-3@2x.png" width="620px" alt />
          </div>
        </el-col>
      </el-row>
    </div>
    <footers></footers>
  </div>
</template>

<script>
import header from "../components/headers";
import footer from "../components/footer";
export default {
  components: {
    headers: header,
    footers: footer
  }
};
</script>

<style lang="less" scoped>
.retail {
  main {
    text-align: center;
    padding-bottom: 100px;
    @media screen and (max-width: 850px) {
      .canpin {
        display: none;
      }
      .smallcanpin {
        display: block;
      }
      .shangpin {
        display: none;
      }
      .smallshangpin {
        display: block;
      }
    }
    @media screen and (min-width: 850px) {
      .canpin {
        display: block;
      }
      .smallcanpin {
        display: none;
      }
      .shangpin {
        display: block;
      }
      .smallshangpin {
        display: none;
      }
    }
    .main_top {
      margin: 40px 0;
      margin-top: -20px;
      h4 {
        font-weight: 400;
        font-size: 28px;
        margin-bottom: 19px;
        margin-top: 30px;
      }
      p {
        font-size: 18px;
      }
      @media screen and (max-width: 850px) {
        h4 {
          font-size: 14px;
          margin-bottom: 9px;
        }
        p {
          font-size: 9px;
        }
      }
    }
    .box {
      // padding: 20px 31px;
      cursor: pointer;
      transition: all 0.5s;
      &:hover {
        transform: translateY(-4px);
      }
      display: flex;
      justify-content: flex-start;
      margin: 24px 19px;
      .infobox {
        padding: 50px 0;
        border: 1px solid #bdddfe;
        box-shadow: 0px 10px 12px #f0f4fd;
        border-radius: 4px;
        min-width: 250px;
        max-width: 250px;
        p {
          font-size: 14px;
          line-height: 25px;
          color: #666;
          font-family: MicrosoftYaHei;
          &:nth-of-type(1) {
            height: 50px;
          }
          &:nth-of-type(2) {
            font-size: 18px;
            margin: 17px 0;
          }
          img {
            height: 100%;
          }
        }
      }
    }
    .smallcanpin {
      text-align: left;
      h2 {
        font-size: 16px;
        color: #2e2e2e;
        font-weight: 400;
        margin: 11px 0;
        position: relative;
        padding-left: 28px;

        &::after {
          content: "";
          background-color: #258ffc;
          border-radius: 5.5px;
          width: 4px;
          height: 16px;
          overflow: hidden;
          position: absolute;
          top: 3px;
          left: 13px;
        }
      }
    }
    .smallshangpin {
      padding: 0 15px;
      ul {
        overflow: hidden;
        width: 100%;

        li {
          width: 48%;
          // height: 150px;
          margin-right: 12px;
          margin-bottom: 15px;
          padding: 20px 10px;
          float: left;
          border-radius: 3px;
          border: 1px solid #258ffc;
          box-shadow: 0 8px 10px rgba(0, 0, 0, 0.2);
          &:nth-of-type(even){
            margin-right: 0;
          }
          p {
            font-size: 10px;
            line-height: 20px;
            white-space: nowrap;
            &:nth-of-type(1) {
              height: 40px;
              img {
                width: 30px;
              }
            }
            &:nth-of-type(2) {
              font-size: 16px;
              line-height: 35px;
            }
          }
        }
      }
    }
  }
  .science {
    @media screen and (max-width: 850px) {
      .smallscience {
        display: block;
        h2 {
          font-size: 16px;
          color: #2e2e2e;
          font-weight: 400;
          margin: 11px 0;
          position: relative;
          padding-left: 28px;

          &::after {
            content: "";
            background-color: #258ffc;
            border-radius: 5.5px;
            width: 4px;
            height: 16px;
            overflow: hidden;
            position: absolute;
            top: 3px;
            left: 13px;
          }
        }
      }
      .lunbotu {
        display: none;
      }
      .smalllunbotu {
        display: block;
      }
      .xiangqing {
        margin-top: 40px;
        margin-bottom: 40px;
      }
    }
    @media screen and (min-width: 850px) {
      .smallscience {
        display: none;
      }
      .lunbotu {
        display: block;
      }
      .smalllunbotu {
        display: none;
      }
    }
    background-color: #f0efef;
    padding: 50px 0;
    padding-bottom: 100px;
    .science_top {
      text-align: center;
      margin: 40px 0;
      margin-top: -20px;
      h4 {
        font-weight: 400;
        font-size: 28px;
        margin-bottom: 19px;
        margin-top: 30px;
      }
      p {
        font-size: 18px;
      }
      @media screen and (max-width: 850px) {
        h4 {
          font-size: 14px;
          margin-bottom: 9px;
        }
        p {
          font-size: 9px;
        }
      }
    }
    .science_left {
      p {
        line-height: 25px;
      }
    }
    .yyy {
      padding: 10px 0;
      cursor: pointer;
      transition: all 1s;
      &:hover {
        transform: translateY(-3px);
        box-shadow: 0 3px 3px #eee;
      }
      img {
        margin-right: 5px;
        vertical-align: middle;
      }
      span {
        color: #2891fc;
        vertical-align: middle;
      }
    }
  }
  @media screen and (max-width: 850px) {
    .feature {
      display: none;
    }
  }
  .feature {
    // position: relative;
    height: 870px;
    background: url("../assets/tupian.png") no-repeat center center;
    // background-size: 100%;
    .grid-content_1 {
      &:nth-child(odd) {
        margin-left: 34px;
      }
      &:nth-child(even) {
        margin-left: 5px;
      }
      &:hover {
        box-shadow: 1px 1px 1px #ccc;
      }
      width: 100px;
      .imgBox {
        position: relative;
        background-color: #fff;
        width: 100%;
        img {
          display: block;
        }
        b {
          position: absolute;
          // top: 5px;
          // left: 25px;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          font-size: 45px;
          color: #fff;
          // &:nth-of-type(odd){
          //   transform: translate(-80%,-50%)!important ;
          // }
          // &:nth-of-type(even){
          //   transform: translate(-50%,-50%)!important ;
          // }
        }
        .imgBoxInfo {
          position: absolute;
          width: 250px;
          height: 80px;
          padding: 0 10px;
          left: 100px;
          top: 0;
          background-color: #fff;
          p {
            font-size: 14px;
            color: #666;
          }
        }
      }
    }
  }
  .proto {
    background-color: #fff;
    padding: 40px 0;
    .smallproto {
      @media screen and (min-width:850px) {
        display: none;
      }
      h2 {
        font-size: 16px;
        color: #2e2e2e;
        font-weight: 400;
        margin: 11px 0;
        position: relative;
        padding-left: 28px;

        &::after {
          content: "";
          background-color: #258ffc;
          border-radius: 5.5px;
          width: 4px;
          height: 16px;
          overflow: hidden;
          position: absolute;
          top: 3px;
          left: 13px;
        }
      }
    }
    .proto_top {
      text-align: center;
      margin: 40px 0;
      margin-top: -20px;
      h4 {
        font-weight: 400;
        font-size: 28px;
        margin-bottom: 19px;
        margin-top: 30px;
      }
      p {
        font-size: 18px;
      }
      @media screen and (max-width: 850px) {
        h4 {
          font-size: 14px;
          margin-bottom: 9px;
        }
        p {
          font-size: 9px;
        }
      }
    }
    .proto_b {
      text-align: center;
      @media screen and (max-width: 850px) {
        img {
          width: 100%;
          &:nth-of-type(1){
            width: 70%;
          }
        }
      }

      img {
        margin: 40px 0;
        transition: all 1s;
        cursor: pointer;
        &:hover {
          transform: scale(1.2);
        }
      }
    }
  }
}
</style>